// Cleanup helpers for Bootstrap tooltips in a Blazor app.
// Blazor can remove DOM elements while Bootstrap tooltip instances still exist.
// Disposing them proactively avoids errors during navigation/modals.

(function () {
  function getTooltip() {
    const bs = window.bootstrap;
    return bs && bs.Tooltip;
  }

  function safeDisposeInstance(instance) {
    if (!instance || typeof instance.dispose !== 'function') return;
    try {
      instance.dispose();
    } catch {
      // ignore
    }
  }

  function cleanupTooltips(root) {
    const Tooltip = getTooltip();
    if (!Tooltip) return;

    // Dispose any tooltips under root
    const scope = root || document;
    const nodes = scope.querySelectorAll('[data-bs-toggle="tooltip"], [data-bs-original-title], [aria-describedby]');

    nodes.forEach((el) => {
      try {
        const instance = Tooltip.getInstance?.(el);
        if (instance) {
          safeDisposeInstance(instance);
          return;
        }

        // If no instance tracked but aria-describedby exists, remove it.
        // This is defensive only.
        if (el && el.removeAttribute && el.hasAttribute('aria-describedby')) {
          el.removeAttribute('aria-describedby');
        }
      } catch {
        // ignore
      }
    });

    // Also remove any stray tooltip DOM nodes
    document.querySelectorAll('.tooltip').forEach((tip) => {
      try {
        tip.remove();
      } catch {
        // ignore
      }
    });
  }

  // Expose for Blazor/other scripts.
  window.bootstrapTooltipCleanup = {
    cleanupTooltips
  };

  // Best-effort: cleanup on pagehide (covers navigation/unload)
  window.addEventListener('pagehide', () => cleanupTooltips(document));
})();
